import MileageSettingsDetails from "../../../../../common/services/mileage/settings/details/mileage-settings-details";
import mileageAddFormHelper from "./mileage-add-form.helper";
import MileageAddFormSettings from "./types/mileage-add-form-settings";

const createSettings = (
  settings: MileageSettingsDetails | null,
): MileageAddFormSettings => {
  if (!settings) {
    return mileageAddFormHelper.getDefaultSettings();
  }

  return {
    isCardNumberRequired: settings.isCardNumberRequired,
    isMileageNumberRequired: settings.isMileageNumberRequired,
    mileageNumberCreationModel: settings.mileageNumberCreationModel,
  };
};

const mileageAddFormFactory = {
  createSettings,
};

export default mileageAddFormFactory;
